var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 639.8 229.3",
    style: {
      enableBackground: "new 0 0 639.8 229.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.6,59.6h4.3v29.6c0,2.4-0.4,4.2-0.4,4.2h0.2c1.7-4.8,8.9-14.5,21.8-14.5c13.3,0,16.9,7.9,16.9,20v32.5 H160v-31c0-8.9-1.1-17.3-12.6-17.3c-9.6,0-18.2,6.8-20.7,16.3c-0.6,2.2-0.8,4.5-0.8,7v25h-4.3V59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.5,146.4c0,0,2.9,2.5,6.4,2.5c4.9,0,8-4.4,10.1-9.2l3.7-8.5l-21.2-51h4.6l16.9,40.9 c1,2.5,1.8,4.8,1.8,4.8h0.2c0,0,0.7-2.4,1.7-4.8l16.9-40.9h4.6l-26.4,63.3c-2.3,5.3-6.6,9.5-13,9.5c-4.9,0-8.3-2.9-8.3-2.9 L179.5,146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.1,80.1h4.3v6.2c0,2.4-0.3,4.1-0.3,4.1h0.2c0,0,4.2-11.5,18.5-11.5c13.8,0,22.2,11,22.2,26.9 c0,16.3-9.5,26.9-22.8,26.9c-13.3,0-18-11.6-18-11.6H244c0,0,0.4,1.8,0.4,4.5v26.4h-4.3V80.1z M262.1,128.4 c10.1,0,18.3-8.3,18.3-22.7c0-13.9-7.4-22.7-17.9-22.7c-9.4,0-18.3,6.7-18.3,22.8C244.3,117.3,250.6,128.4,262.1,128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.9,78.9c14,0,20.9,11,20.9,23.4c0,1.1-0.2,2.8-0.2,2.8h-41.1c0,14.9,10.1,23.4,22,23.4 c9.9,0,15.9-6.5,15.9-6.5l2.4,3.6c0,0-7.2,7.1-18.3,7.1c-14.5,0-26.5-10.5-26.5-26.8C300,88.5,311.8,78.9,324.9,78.9z M341.4,101 c-0.5-12.5-8-18.2-16.5-18.2c-9.4,0-18.2,6.2-20,18.2H341.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.4,80.1h4.3v9.7c0,2.4-0.4,4.2-0.4,4.2h0.2c2.6-7.9,8.3-14.4,16.4-14.4c1.5,0,3,0.3,3,0.3v4.3 c0,0-1.2-0.2-2.4-0.2c-8,0-13,6.8-15.3,14.4c-1.1,3.6-1.5,7.4-1.5,10.8v22.2h-4.3V80.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.7,59.6h4.3v60.1c0,7.2,3.7,8,6.1,8c0.8,0,1.5-0.1,1.5-0.1v4c0,0-0.9,0.2-1.8,0.2c-3,0-10.1-1.1-10.1-10.8V59.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.5,100.1h3.4v-1.7c0-11.4-5.8-15.3-14.1-15.3c-8.9,0-14.7,4.9-14.7,4.9l-2.5-3.5c0,0,6.2-5.6,17.3-5.6 c11.8,0,18.2,6.6,18.2,19.4v33.1h-4.3v-6.8c0-2.8,0.4-4.6,0.4-4.6h-0.2c0.1,0-4.6,12.6-18,12.6c-8.3,0-17.4-4.6-17.4-14.9 C426.7,100.3,449.4,100.1,458.5,100.1z M444.4,128.6c11.2,0,17.5-11.6,17.5-21.8v-2.8h-3.3c-8.7,0-27.4,0-27.4,13.3 C431.2,122.9,435.7,128.6,444.4,128.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489,84.3h-6.8v-3.9h6.8V65.8h4.3v14.6h13.4v3.9h-13.4v28.2c0,13.5,8.1,15.3,12.2,15.3c1.4,0,2.4-0.2,2.4-0.2v4 c0,0-1,0.2-2.6,0.2c-5.3,0-16.3-1.9-16.3-19V84.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.7,59.6h4.3v29.6c0,2.4-0.4,4.2-0.4,4.2h0.2c1.7-4.8,8.9-14.5,21.8-14.5c13.3,0,16.9,7.9,16.9,20v32.5h-4.3v-31 c0-8.9-1.1-17.3-12.6-17.3c-9.6,0-18.2,6.8-20.7,16.3c-0.6,2.2-0.8,4.5-0.8,7v25h-4.3V59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.3,78.9c14,0,20.9,11,20.9,23.4c0,1.1-0.2,2.8-0.2,2.8h-41.1c0,14.9,10.1,23.4,22,23.4c9.9,0,15.9-6.5,15.9-6.5 l2.4,3.6c0,0-7.2,7.1-18.3,7.1c-14.5,0-26.5-10.5-26.5-26.8C584.3,88.5,596.1,78.9,609.3,78.9z M625.7,101 c-0.5-12.5-8-18.2-16.5-18.2c-9.4,0-18.2,6.2-20,18.2H625.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.1,99.9c0,0.6-0.3,1-0.8,1.1c-0.5,0.1-2.6,0.2-6.1,0.2c-4.6,0-8.4,0.7-11.3,2.2c-3.5,1.8-5.9,3.6-7,5.4 c-1.2,1.8-3.1,6.6-5.8,14.4L44.7,144c-3.1,8.5-6.2,14.9-9.4,19.2c-3.2,4.3-7.7,7.7-13.3,10.4c-5.6,2.7-11.9,4-18.9,4 c-2.1,0-3.1-0.5-3.1-1.4c0-0.9,1.2-1.4,3.7-1.6c6.1-0.4,10.4-1.8,12.8-4.2c2.4-2.4,5.2-7.8,8.2-16.1l8.4-22.7 c3.9-10.6,8.6-18.3,14.2-23c5.6-4.8,13.7-7.9,24.4-9.3c-5.4-1-9.7-3.2-12.9-6.6c-3.2-3.4-4.9-7.4-4.9-11.9c0-4.1,2-11.3,6-21.6 l4.4-11.2c2-5,2.9-9.4,2.9-13.3c0-3.7-1.5-6-4.6-7.1c-1.7-0.6-4.8-0.9-9.3-0.9c-1.1,0-1.6-0.4-1.6-1.1c0-0.9,0.7-1.3,2.2-1.3 c6.6,0,12.1,0.7,16.7,2.2c6.8,2.2,10.3,6.9,10.3,14.1c0,2.9-1.2,7.6-3.5,13.9l-5.9,15.9C68.5,78.9,67,84.9,67,88.7 c0,6.8,4.8,10.2,14.3,10.1C82.5,98.8,83.1,99.1,83.1,99.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8977d6d615f625fa1deeba95effb644d.svg";
export { ForwardRef as ReactComponent };